module.exports = __webpack_public_path__ + "img/MobileTab.196b75e5.png";